import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActionSheetController, AlertController, LoadingController, ToastController, ModalController } from '@ionic/angular';


import { ServiceCategory } from '../../../models/service-category/service-category.model';
import { ServiceCategoryService } from '../../../services/service-category.service';

import { AlertService } from '../../../utilities/alert.service';
import { ToastService } from '../../../utilities/toast.service';

@Component({
  selector: 'app-service-category-form',
  templateUrl: './service-category-form.component.html',
  styleUrls: ['./service-category-form.component.scss'],
})
export class ServiceCategoryFormComponent implements OnInit {

  public isLoading: boolean;

  public submitAttempt: boolean;

  public savingInProgress: boolean;

  @Input() serviceCategory: ServiceCategory;

  public serviceCategoryForm: UntypedFormGroup;

  public serviceCategoryField: UntypedFormControl;

  constructor(
    //private viewCtrl: ViewController,
    //private navParams: NavParams,
    private serviceCategoryService: ServiceCategoryService,
    private alertCtrl: AlertController,
    private formBuilder: UntypedFormBuilder,
    private actionSheetCtrl: ActionSheetController,
    private toastCtrl: ToastController,
    private modalCtrl: ModalController,
    private readonly alertService: AlertService,
    private loadingCtrl: LoadingController,
    private readonly toastService: ToastService,) {

    this.isLoading = false;
    this.submitAttempt = false;
    this.savingInProgress = false;
    // this.serviceCategory = this.navParams.get('serviceCategory');
    //  this.serviceCategory = route.snapshot.params.serviceCategory;
    //    this.route.params.subscribe({
    //        next: (params) => {
    //          this.serviceCategory = params.serviceCategory;
    //   }
    // });

  }

  ngOnInit() {

    this.serviceCategoryField = new UntypedFormControl(this.serviceCategory.getCategoryName(), Validators.required);
    this.serviceCategoryForm = this.formBuilder.group({
      serviceCategory: this.serviceCategoryField
    });
  }

  public async onServiceCategoryFormSave() {
    this.submitAttempt = true;

    if (!this.serviceCategoryForm.valid) {
      return;
    }

    this.savingInProgress = true;
    this.serviceCategory = this.serviceCategory.setCategoryName(this.serviceCategoryField.value);
    try {
      const res = await this.serviceCategoryService.saveServiceCategory(this.serviceCategory)
      this.savingInProgress = false;
      this.modalCtrl.dismiss(res);
    }
    catch (err) {
      this.savingInProgress = false;
      this.alertService.presentErrorAlert();
    }
  }

  public onDismiss() {
    this.modalCtrl.dismiss(null);
  }


  public async onDeleteServiceCategory() {
    const actionSheet = await this.actionSheetCtrl.create({
      header: 'Are you sure you want to delete this service category?',
      buttons: [
        {
          text: `Yes, delete this service category`,
          icon: 'trash',
          role: 'destructive',
          cssClass: 'sm-error',
          handler: () => {

            actionSheet.dismiss().then(async () => {
                  const loader = await this.loadingCtrl.create({
                    spinner: 'crescent',
                  });

                  loader.present();


              this.serviceCategoryService.deleteServiceCategory(this.serviceCategory)
                .subscribe({
                  next: (success) => {
                    loader.dismiss().then(() => {
                      this.modalCtrl.dismiss(this.serviceCategory).then(() => {
                        this.toastService.presentSimpleToast(`Service category has been deleted.`, 3000);
                      });
                    });
                  },
                  error: (e) => {
                    loader.dismiss().then(() => {
                      this.alertService.presentErrorAlert();
                    });
                  }
                });
            });

            return false;
          }
        },
        {
          text: 'Cancel',
          role: 'cancel',
          icon: 'close',
          handler: () => {
            actionSheet.dismiss();
            return false;
          }
        }
      ]
    });

    return await actionSheet.present();
  }

}
